import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const WaitingIcon: React.FC = () => {

    return (
        <div style={{
            width:'100%',
            padding: '100px',
            display:'flex',
            alignItems:'center',
            alignContent:'center',
            justifyContent:'center'
        }}>
            <FontAwesomeIcon icon={faSpinner} pulse color='#74777a' size='2x' />
        </div>
    );
}

export { WaitingIcon };